import { RawKey } from '@master/annotation/RawKey'
import { Meta } from '@master/model/common/Meta'
import { IDateService } from '@master/services/IDateService'
import { cid, container } from 'inversify-props'

export const PayeeFullMetaHeaders = [
  '_oid',
  'payee_fullname',
  'payee_email',
  'payee_nric',
  'payee_company_code',
  'payee_contact',
  'payee_dob',
  'payee_pob',
  'payee_address',
  'payee_postal_code',
  'payee_country',
  'payee_bank_name',
  'payee_bank',
  'payee_swift_code'
]

export class PayeeFullMeta extends Meta {
  @RawKey('_oid')
  oid = ''

  payeeFullname = undefined
  payeeEmail = undefined
  payeeNric = undefined
  payeeCompanyCode = undefined
  payeeContact = undefined
  payeeDob = undefined
  payeePob = undefined
  payeeAddress = undefined
  payeePostalCode = undefined
  payeeCountry = undefined
  payeeBankName = undefined
  payeeBank = undefined
  payeeSwiftCode = undefined

  convertToRawData (keyToConvert?: string[], convertNested = false) {
    const raw = super.convertToRawData(keyToConvert, convertNested) as any
    const dateService = container.get<IDateService>(cid.IDateService)
    Object.assign(raw, { payee_dob: dateService.format(raw.payee_dob, 'YYYY-MM-DD') }) // eslint-disable-line @typescript-eslint/camelcase
    return raw
  }
}
